<template>
  <div>
    <CRow v-if="line_info.title!=null">
      <CCol col="12 col-sm-8">
        <CCard>
          <CCardHeader>
            <div class="d-flex align-items-center">
              <img :src="admin_info.image" class="rounded-circle p-2"  width="70px" height="70px"/>

              <strong>لاین {{ line_info.title }}
                {{admin_info.name}}
              </strong>

            </div>

          </CCardHeader>
          <CCardBody>
            <CCardBody>
              <CRow>
                <CCol col="12 col-md-6">
                  <date-picker
                      v-model="selected_date"
                      inline
                  />
                </CCol>

                <CCol col="12 col-md-6">
                  <div  v-if="line_reserves.length>0">
                    <CButton
                        size="sm"
                        color="danger"
                        @click="delete_item_dialog(line_info)"
                    >
                      حذف کلی ساعات روز
                      {{get_date(selected_date)}}</CButton>
                    <div :class="`reserve_time_list`">
                      <div @click="change_time_status(reserve)" v-for="reserve in line_reserves"
                           :class="`reserve_time_item ${reserve.orders_count>0? 'reserved':'' } ${reserve.status==0? 'disabled':'' }`" :key="'time'+reserve.id">
                        {{get_time(reserve.date)}}
                      </div>
                    </div>
                  </div>

                  <div v-else>
                    ساعات رزرو خالی است لطفا ساعات این روز را ثبت کنید
                  </div>
                </CCol>


              </CRow>


            </CCardBody>
          </CCardBody>

        </CCard>
      </CCol>
      <CCol col="12 col-sm-4">
        <CCard>
          <CCardHeader>
            <strong>ثبت ساعات رزرو</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <date-picker
                    v-model="start_time"
                    label="از ساعت"
                    display-format="HH:mm"
                    input-format="HH:mm"
                    format="HH:mm"
                    type="time"
                />

              </CCol>

              <CCol col="12">
                <date-picker
                    v-model="end_time"
                    label="تا ساعت"
                    display-format="HH:mm"
                    input-format="HH:mm"
                    format="HH:mm"
                    type="time"
                />

              </CCol>
              <CCol col="12">
                <CInput
                    v-model="every_minute"
                    label="هر (دقیقه)"
                    v-on:keypress="isNumber($event)"
                />

              </CCol>
            </CRow>

          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0"
                     @click="login()"
                     type="submit" ref="submit_form" size="sm" color="primary">
              افزودن لیست زمان رزرو
            </CButton>

            <CButton v-if="status_form!=0"
                     @click="cancel_form()"
                     class="mr-1"

                     size="sm" color="danger">
              {{ $t('cancel') }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>


  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      selected_date: '',
      name: '',
      code: '',
      file: [],
      line_info: {},
      admin_info: {},
      color: '',
      previewImage: null,
      description: '',
      start_time: '09:00',
      end_time: '20:00',
      every_minute: 60,
      line_reserves: [],

      status_form: 0,

    }
  }, mounted() {
    this.selected_date = this.get_today()
    this.get_categories();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_date':function (){
      this.get_line_reserve_times()
    }
  },
  methods: {

    cancel_form() {
      this.name = '';
      this.description = '';
      this.previewImage = null;
      this.file = [];

      this.status_form = 0;

    },
    editDetails(item) {
      this.name = item.title;
      this.code = item.code;
      this.status_form = item.id;

    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/get_line_info', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.admin_info = content_cats.user
        self.line_info = content_cats.data

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_line_reserve_times() {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('selected_date', this.selected_date)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/get_line_reserve_times', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.line_reserves = content_cats.data

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    change_time_status(reserve) {
      var self = this;
      var formData = new FormData();
      formData.append('id', this.$route.params.id)
      formData.append('reserve_id', reserve.id)
      formData.append('admin_id', this.$route.params.admin_id)
      axios.post('/api/admin/site/change_time_status', formData, {}).then(function (response) {

        self.$root.modal_component.show_api_response_modals(response);
       self.get_line_reserve_times();
      })
          .catch(function (error) {

            console.log(error);
          });

    },


    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line_reserve_times";
      }
      formData.append('id', this.$route.params.id)
      formData.append('admin_id', this.$route.params.admin_id)

      formData.append('start_time', this.start_time);
      formData.append('end_time', this.end_time);
      formData.append('every_minute', this.every_minute);
      formData.append('selected_date', this.selected_date);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {

          self.get_line_reserve_times();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line_reserve_times";

      formData.append('admin_id', this.$route.params.admin_id)
      formData.append('id', this.$route.params.id);
      formData.append('selected_date', this.selected_date);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_line_reserve_times();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>
<style>
.reserve_time_list{
  display: flex;
  flex-flow: wrap;
}
.reserve_time_item{
  border: 1px solid orangered;
  padding: 7px;
  margin: 2px;
  border-radius: 5px;
}

.reserve_time_item.reserved{
  border: 1px solid #39f;
color:white;
  background: #39f;
}

.reserve_time_item.disabled{
  border: 1px solid darkslategray;
  color:white;
  background: darkslategray;

}


</style>